import {pipeHandlers} from 'utils/reduxEffects';
import dashboardPage from './dashboardPage/handler';
export default pipeHandlers(dashboardPage);
